module.exports = __webpack_public_path__ + "img/trip_08.f040d104.jpg";